export const comments_3253776 = {"data":{"data":[],"links":{}}}